<template>
  <div class="home">
    <div class="img">
      <img :src="$store.getters.systemLogoHome" />
    </div>

    <!-- <div id="dashboard">
            <b-button class="b1">Dashboard</b-button>
            <div class="back  home-image-hover"></div>
    </div>-->
    <div id="CheckList">
      <router-link
        v-if="$store.getters.isChecklistFormCreator"
        class="link"
        to="/checklist/dashboard/default/"
      >
        <b-button class="b2">CheckList</b-button>
      </router-link>
      <router-link
        v-else-if="$store.getters.isChecklistFormFiller"
        class="link"
        to="/checklist/Layout/form/own/"
      >
        <b-button class="b2">CheckList</b-button>
      </router-link>
      <router-link
        v-else-if="$store.state.checklist"
        class="link"
        to="/checklist/Layout/form/Filled/"
      >
        <b-button class="b2">CheckList</b-button>
      </router-link>
      <router-link v-else class="link" to>
        <b-button class="b2 disabled-module">CheckList</b-button>
      </router-link>
      <div class="back home-image-hover"></div>
    </div>
    <div id="Workflow">
      <router-link
        v-if="$store.getters.hasAccessWorkflow"
        class="link"
        to="/workflow/processList"
      >
        <b-button class="b3">Workflow</b-button>
      </router-link>
      <router-link v-else class="link" to>
        <b-button class="b3 disabled-module">Workflow</b-button>
      </router-link>
      <div class="back home-image-hover"></div>
    </div>
    <div id="Tracking">
      <router-link
        v-if="$store.getters.isCompanyShipper"
        class="link"
        to="/dashboard/"
      >
        <b-button class="b3">Tracking</b-button>
      </router-link>
      <router-link
        v-else-if="$store.getters.isCargoKanbamAvaliable"
        class="link"
        to="/trackingShippingCompany/cargo/kanban/"
      >
        <b-button class="b3">Torre de Controle</b-button>
      </router-link>
      <router-link
        v-else-if="$store.getters.isCargoExpensesAvaliable"
        class="link"
        to="/trackingShippingCompany/cargoExpense/kanban"
      >
        <b-button class="b3">Torre de Controle</b-button>
      </router-link>
      <router-link
        v-else-if="$store.getters.hasAccessLoads"
        class="link"
        to="/trackingShippingCompany/cargo/list"
      >
        <b-button class="b3">Torre de Controle</b-button>
      </router-link>
      <router-link v-else class="link" to>
        <b-button class="b3 disabled-module">Torre de Controle</b-button>
      </router-link>
      <div class="back home-image-hover"></div>
    </div>
    <!-- <div id="Comercial">
      <router-link class="link" to>
        <b-button class="b4 disabled-module">Comercial</b-button>
      </router-link>
      <div class="back  home-image-hover"></div>
    </div> -->
    <div id="rh">
      <router-link class="link" to>
        <b-button class="b5 disabled-module">RH</b-button>
      </router-link>
      <div class="back home-image-hover"></div>
    </div>

    <div id="freight-simulator">
      <router-link
        v-if="$store.getters.hasAccessFinancial"
        class="link"
        to="http://3.131.81.214:8081/freight-simulator"
      >
        <b-button class="b3">Simulador de Frete</b-button>
      </router-link>
      <router-link v-else class="link" to>
        <b-button class="b3 disabled-module">Simulador de Frete</b-button>
      </router-link>
      <div class="back home-image-hover"></div>
    </div>

    <div id="ComprasOrcamento">
      <router-link class="link" to>
        <b-button class="b7 disabled-module">Fiscal & Financeiro</b-button>
      </router-link>
      <div class="back home-image-hover"></div>
    </div>
    <div id="bi">
      <router-link v-if="userReleases.bi" class="link" to="/bi/">
        <b-button class="b8">BI</b-button>
      </router-link>
      <router-link v-else class="link" to>
        <b-button class="b8 disabled-module">BI</b-button>
      </router-link>
      <div class="back home-image-hover"></div>
    </div>
    <div id="Financial">
      <router-link
        v-if="$store.getters.hasAccessFinancial"
        class="link"
        to="/financial/dashboard"
      >
        <b-button class="b3">Financial</b-button>
      </router-link>
      <router-link v-else class="link" to>
        <b-button class="b3 disabled-module">Financial</b-button>
      </router-link>
      <div class="back home-image-hover"></div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      userReleases: {
        bi: false
      }
    };
  },

  created() {
    this.$apiScheduler.get("/profileUser/getUserReleases").then(response => {
      this.userReleases = response.data;
    });
    this.validateUser();
  },
  methods: {
    validateUser() {
      this.$apiScheduler
        .get("/validateUser/")
        .then(response => {})
        .catch(error => {
          if (error.response.status == 401) {
            this.$router.push({ path: "home" });
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else if (error.response.status == 404) {
            this.$router.push("/login");
          }
          console.log(error);
          console.log(error.response.data.errors);
          return null;
        });
    }
  }
};
</script>

<style scoped>
/* .home #dashboard .b1:hover ~ .back {
    background-image: url('./img/BI.jpeg');
    background-repeat: no-repeat;
} */

.home {
  text-align: center;
}

@media (min-width: 768px) {
  .home {
    display: flex;
    justify-content: space-evenly;
  }
  .home .img {
    margin-top: 200px;
    position: absolute;
    width: 600px;
    /* height: 300px; */
    z-index: -2;
  }
}

.b2,
.b3,
.b4,
.b5,
.b6,
.b7,
.b8 {
  width: 300px;
  height: 80px;
}

@media (min-width: 768px) and (max-width: 992px) {
  .b2,
  .b3,
  .b4,
  .b5,
  .b6,
  .b7,
  .b8 {
    width: 110px;
    height: 80px;
    margin-top: 31rem;
    padding: 0px;
  }
}

@media (min-width: 992px) {
  .b2,
  .b3,
  .b4,
  .b5,
  .b6,
  .b7,
  .b8 {
    width: 140px;
    height: 120px;
    margin-top: 31rem;
  }
}
@media (min-width: 1200px) {
  .b2,
  .b3,
  .b4,
  .b5,
  .b6,
  .b7,
  .b8 {
    width: 180px;
    height: 150px;
    margin-top: 31rem;
  }
}
@media (min-width: 1500px) {
  .b2,
  .b3,
  .b4,
  .b5,
  .b6,
  .b7,
  .b8 {
    width: 180px;
    height: 150px;
    margin-top: 43rem;
  }
}

.disabled-module {
  background: gray !important;
  cursor: not-allowed !important;
}

/* 
.home #CheckList .link:hover ~ .back {
  background-image: url("./img/checklist_01.png");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: contain;
}

.home #Tracking .link:hover ~ .back {
  background-image: url("./img/track_01.jpg");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: contain;
}
.home #Workflow .link:hover ~ .back {
  background-image: url("./img/track_01.jpg");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: contain;
}

.home #Comercial .link:hover ~ .back {
  background-image: url("./img/forca-vendas.jpg");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: contain;
}

.home #rh .link:hover ~ .back {
  background-image: url("./img/rh_01.jpg");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: contain;
}

.home #Qualidade .link:hover ~ .back {
  background-image: url("./img/85388-entenda-o-que-e-a-garantia-da-qualidade-em-seus-projetos.jpg");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: contain;
}

.home #ComprasOrcamento .link:hover ~ .back {
  background-image: url("./img/compra-facil-market-place.webp");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: contain;
}

.home #bi .link:hover ~ .back {
  background-image: url("./img/bi_01.png");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: contain;
} */

.back {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: -1;
}

.home .footer {
  position: absolute;
  margin-top: 46%;
}
</style>
